import axios from "axios";
import { ROUTES } from "../shared/utils/constants";

const API_BASE_URL =
  import.meta.env.VITE_API_BASE_URL || "https://localhost:8080";

const API_WITH_CREDENTIALS = import.meta.env.VITE_API_WITH_CREDENTIALS === "true";

export const apiClient = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    "Content-Type": "application/json",
  },
  timeout: 10000,
  withCredentials: true,
});


apiClient.interceptors.response.use(
  (response) => response,
  (error) => {
    const status = error.response?.status;
    const errorData = error.response?.data;
    const isAuthRequest = error.config?.url?.includes("/auth/");

    if (status === 401 && !isAuthRequest) {
      window.location.href = ROUTES.LOGIN;
    }

    if (
      status === 403 &&
      errorData?.error === "REFRESH_FAILED" &&
      errorData?.message === "Unable to refresh token"
    ) {
      window.location.href = ROUTES.LOGIN;
    }

    return Promise.reject(error);
  }
);

export default apiClient;
